import { Breadcrumb } from 'lib/_types'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setBreadcrumb as setBreadcrumbAction } from '../store/actions/uiState'

export const useBreadcrumb = () => {
  const dispatch = useDispatch()
  const setBreadcrumb = useCallback(
    (breadcrumb: Breadcrumb[]) => {
      dispatch(setBreadcrumbAction(breadcrumb))
    },
    [dispatch]
  )

  useEffect(() => {
    return () => {
      setBreadcrumb([])
    }
  }, [])

  return {
    setBreadcrumb,
  }
}
